import { getPickupClosingSoonText } from '../../../../utils/utils';

const ClosingSoonTimeRenderer = ({ value }) => {
  return value !== null ? getPickupClosingSoonText(value) : null;
};

export default ClosingSoonTimeRenderer;
